import { RestoreFromVersionArguments } from './types';

export const buildRestoreFromVersionPayload = ({
  id,
}: Pick<RestoreFromVersionArguments, 'id'>): { sourceId: string } => {
  return { sourceId: id };
};
